
import {isIOS, requestWxstr} from '@/api/scanCode'
import MescrollVue from 'mescroll.js/mescroll'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {load2, queryvirtualroomdevice, sendcommand, sendcommandlock, setdevice} from '../../api/device'
import { isServicePlanAllowed } from '@/api/servicePlan'

export default {
name: 'NewDevice1',
components: {
MescrollVue 
},
directives: {
TransferDom
},
data () {
return {
meScroll: null, // meScroll实例对象
meScrollDown: {
autoShowLoading: true,
callback: this.upCallback,
dataList: [] 
}, // 下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则meScrollDown可不用写了)

selectHomeShow: false,
selectHome: '',
selectHomeArr: [],
deviceImgArr: [],
deviceArr: [],
showDeviceArr: []
}
},
created () {
this.golobleObject.changeDevicePage = this.mqttChangeDevice
this.golobleObject.getMqttDoor = this.mqttChangeDoorStatus
this.token = this.$store.getters.get_token
this.deviceImgArr = this.common.getDeviceImg()
if (this.isWx()) {
if (!isIOS()) {
requestWxstr()
}
}
},
methods: {
isNbOrNon4G (dtype) {
if (this.common && this.common.isNbOrNon4G) {
return this.common.isNbOrNon4G(dtype)
}
return false
},
getServiceExpireStatus (item) {
if (!isServicePlanAllowed()) {
return 'normal'
}
if (this.isNbOrNon4G(item.dtype)) {
return 'normal'
}
if (item.service_plan && item.service_plan.expire_status) {
return item.service_plan.expire_status
}
if (item.simcard && item.simcard.expire_status) {
return item.simcard.expire_status
}
return 'normal'
},
getServiceDaysLeft (item) {
if (item.service_plan && typeof item.service_plan.days_left !== 'undefined') {
return item.service_plan.days_left
}
if (item.simcard && typeof item.simcard.days_left !== 'undefined') {
return item.simcard.days_left
}
return 0
},
gotoServiceList () {
this.$router.push('/deviceServiceList')
},

mqttChangeDevice (obj) {
if (obj.type === 'lockdoor') { // 401开关门状态、开关锁状态
this.deviceArr.forEach(deviceGroup => {
let device = deviceGroup.deviceList.find(r => r.id === parseFloat(obj.alarm.did))
if (device) {
if (obj.alarm.alarmtype === 'wifilock_open') {
this.$toast('开锁成功')
device.mainConfig.lockStatus.value = 0
} else if (obj.alarm.alarmtype === 'wifilock_close') {

device.mainConfig.lockStatus.value = 1
} else if (obj.alarm.alarmtype === 'lockopendoor') {
device.mainConfig.doorStatus.value = 1
} else if (obj.alarm.alarmtype === 'lockclosedoor') {
device.mainConfig.doorStatus.value = 0
}
}
})
} else if (obj.type === 'deviceStatus') {
this.deviceArr.forEach(deviceGroup => {
let device = deviceGroup.deviceList.find(r => r.deviceid === obj.alarm.imei)
if (device) {
if (obj.alarm.activestate) {
device.mainConfig.activeState.value = obj.alarm.activestate
}
if (obj.alarm.armstatus) {
device.mainConfig.armStatus.value = obj.alarm.armstatus === 'on' ? 1 : 0
}
if (obj.alarm.devicestatus) {
if (obj.alarm.devicestatus === 'door-close') {
device.mainConfig.doorStatus.value = 0
} else if (obj.alarm.devicestatus === 'door-open') {
device.mainConfig.doorStatus.value = 1
}
}
if (obj.alarm.temperature) {
device.mainConfig.temperature.value = obj.alarm.temperature
}
}
})
}
},

mqttChangeDoorStatus (obj) {

this.deviceArr.forEach(deviceGroup => {
let device = deviceGroup.deviceList.find(r => r.id === parseFloat(obj.did))
if (device) {
if (obj.alarmtype === '906info') {
let passThrough = obj.passthrough
const bytes = (passThrough.split('PSAA')[1]).match(/.{1,2}/g).map(byte => parseInt(byte, 16))
if (bytes[0] !== 0x04) {
if (bytes.length >= 3) {
let batteryStatus = bytes[1] & 0x0F
let batteryVol = bytes[2] * 0.2
let batteryPercent = 0
if (batteryVol > 21) {
batteryPercent = 100
} else if (batteryVol < 17.5) {
batteryPercent = 0
} else {
batteryPercent = Math.round(((bytes[2] * 0.2) - 17.5) / (21 - 17.5) * 100)
}
device.mainConfig.batteryStatus.value = batteryStatus
device.mainConfig.batteryVol.value = batteryVol.toFixed(1) + 'V'
device.mainConfig.batteryPercent.value = batteryPercent + '%'
device.mainConfig.outputVol.value = (bytes[3] * 0.2).toFixed(1) + 'V'
}
}
} else {
device.unhandlealarm += 1
if (obj.alarmtype === 'doorclose' || obj.alarmtype === 'door-close') {
device.mainConfig.doorStatus.value = 0
} else if (obj.alarmtype === 'dooropen' || obj.alarmtype === 'door-open') {
device.mainConfig.doorStatus.value = 1
} else if (obj.alarmtype === 'batterylowvoltage') {
device.mainConfig.batteryStatus.value = 3
} else if (obj.alarmtype === 'switchbattery') {
device.mainConfig.batteryStatus.value = 2
} else if (obj.alarmtype === 'switchexternalpower') {
device.mainConfig.batteryStatus.value = 1
}
}
}
})
},

gotoDetail (item) {
this.$store.commit('set_child_obj', item)
this.$router.push('/NewChildList')
},
gotoFamily () {
this.$router.push('/familyManagement')
},
gotoMap (item) {
this.$store.commit('set_child_obj', item)
if (item.dtype === 99 || item.dtype === 300) {
this.$router.push({path: '/AmapNB', query: {Imei: item.deviceid}})
} else if (item.dtype === 901 || item.dtype === 350 || item.dtype === 301 || item.dtype === 310 || item.dtype === 311 ||
item.dtype === 312 || item.dtype === 330 || item.dtype === 331 || item.dtype === 332) {
this.$router.push({path: '/mapCat', query: {Imei: item.deviceid}})
}
},


meScrollInit (meScroll) {
this.meScroll = meScroll 
},
meScrollSuccess () {
let vm = this
this.$nextTick(() => {
setTimeout(() => {
vm.meScroll.endSuccess(0)
}, 100)
})
},
upCallback (page, meScroll) {
let vm = this
this.selectHomeArr = [{name: '全部设备', id: 0}]
this.deviceArr = []
this.showDeviceArr = []
load2().then(res => {
let devices = res.data && res.data.devices ? res.data.devices : []
vm.parseDevices(devices)



queryvirtualroomdevice().then(res => {
let rooms = res.data && res.data.length > 0 ? res.data : []
vm.getDevices(rooms, devices)
if (vm.selectHome === '') {
vm.selectHome = vm.selectHomeArr[0]
}
this.getShowDevices()
console.log(vm.selectHomeArr, vm.deviceArr)
this.meScrollSuccess()
}).catch(() => {
this.meScrollSuccess()
})
}).catch(() => {
this.meScrollSuccess()
})
},
parseDevices (devices) {
let vm = this
devices.forEach(device => {
device.mainConfig = this.parseMainConfig(device)
device.settingObj = this.parseSetting(device)
if (vm.isHaveDefence(device.dtype)) {
if (!device.setting) {
device.setting = [{value: 'off'}]
}
}
})
},
parseMainConfig (device) {
let vm = this


let mainConfig = {}
let mainConfigJson = null
if (device.main_config !== '' && device.main_config !== '{}') {
mainConfigJson = JSON.parse(device.main_config)
while (typeof mainConfigJson === 'string') {
mainConfigJson = JSON.parse(mainConfigJson)
}
}
if (mainConfigJson) {
if (device.dtype === 400) {
mainConfig.lockStatus = {value: 1, time: 0}
} else if (device.dtype === 402 || device.dtype === 404) {
mainConfig.batteryVol = {value: mainConfigJson.battery_voltage, time: 0}
mainConfig.rssi = {value: mainConfigJson.rsrp, time: 0}
mainConfig.signal = {value: vm.parseSignal(device, mainConfig.rssi), time: 0}
} else if (device.dtype === 504 || device.dtype === 506 || device.dtype === 507 || device.dtype === 508 ||
device.dtype === 509 || device.dtype === 510 || device.dtype === 511 || device.dtype === 904 || device.dtype === 905) {
mainConfig.batteryVol = {value: mainConfigJson.battery_voltage, time: 0}
mainConfig.temperature = {value: mainConfigJson.temperature + 4, time: 0}
mainConfig.rssi = {value: mainConfigJson.rsrp, time: 0}
mainConfig.signal = {value: vm.parseSignal(device, mainConfig.rssi), time: 0}
} else if (device.dtype === 503) {
mainConfig.pressValue = {value: mainConfigJson.Press_Value, time: 0}
mainConfig.pressUnits = {value: mainConfigJson.pressure_units, time: 0}
mainConfig.batteryVol = {value: mainConfigJson.Voltage, time: 0}
mainConfig.battery = {value: mainConfigJson.battery_value, time: 0}
} else if (device.dtype === 505) {
mainConfig.tamperStatus = {value: mainConfigJson.tamperstatus, time: 0}
mainConfig.batteryVol = {value: mainConfigJson.voltagevalue, time: 0}
mainConfig.rssi = {value: mainConfigJson.signal, time: 0}
mainConfig.signal = {value: vm.parseSignal(device, mainConfig.rssi), time: 0}
}

let params = mainConfigJson.param ? mainConfigJson.param.split('&') : []
params.forEach(param => {
if (param === 'door-1') {
mainConfig.doorStatus = {value: 1, time: 0} 
} else if (param === 'door-0') {
mainConfig.doorStatus = {value: 0, time: 0} 
} else if (param === 'lock-1') {
mainConfig.lockStatus = {value: 1, time: 0} 
} else if (param === 'lock-0') {
mainConfig.lockStatus = {value: 0, time: 0} 
} else if (param.indexOf('vbat') !== -1) {
let batteryVol = param.split('-')
mainConfig.batteryVol = {value: batteryVol[1].slice(0, (batteryVol[1].length - 2)), time: 0} 
} else if (param.indexOf('rssi') !== -1) {
let rssi = param.split(':')
mainConfig.rssi = {value: rssi[1] ? rssi[1] : '', time: 0} 
mainConfig.signal = {value: vm.parseSignal(device, mainConfig.rssi), time: 0}
}
})

let passThrough = mainConfigJson.passthrough ? mainConfigJson.passthrough : ''
if (device.dtype === 511 || device.dtype === 904 || device.dtype === 905) {
if (passThrough.indexOf('AA0601') > -1) {
mainConfig.electricStatus = {value: '断电', time: 0}
} else if (passThrough.indexOf('AA0602') > -1) {
mainConfig.electricStatus = {value: '上电', time: 0}
}
} else if (device.dtype === 906 || device.dtype === 920) {


const bytes = (passThrough.split('PSAA')[1]).match(/.{1,2}/g).map(byte => parseInt(byte, 16))
if (bytes[0] !== 0x04) {
if (bytes.length >= 3) {
let batteryStatus = bytes[1] & 0x0F
let batteryVol = bytes[2] * 0.2
let batteryPercent = 0
if (batteryVol > 21) {
batteryPercent = 100
} else if (batteryVol < 17.5) {
batteryPercent = 0
} else {
batteryPercent = Math.round(((bytes[2] * 0.2) - 17.5) / (21 - 17.5) * 100)
}
mainConfig.batteryStatus = {value: batteryStatus, time: 0}
mainConfig.batteryVol = {value: batteryVol.toFixed(1) + 'V', time: 0}
mainConfig.batteryPercent = {value: batteryPercent + '%', time: 0}
mainConfig.outputVol = {value: (bytes[3] * 0.2).toFixed(1) + 'V', time: 0}
}
}
} else if (device.dtype === 504) {
let byte = (passThrough + '').slice(0, 1)
if (byte === '0') {
mainConfig.doorStatus = {value: 0, time: 0} 
} else if (byte === '1') {
mainConfig.doorStatus = {value: 1, time: 0} 
}
} else if (device.dtype === 508 || device.dtype === 509) {
if (passThrough.length === 44) {
let byte = (passThrough + '').slice(36, 38)
if (byte === '01') {
mainConfig.doorStatus = {value: 1, time: 0} 
} else if (byte === '02') {
mainConfig.doorStatus = {value: 0, time: 0} 
}
}
}

if (device.dtype === 301 || device.dtype === 310 || device.dtype === 311 || device.dtype === 312 || device.dtype === 330 || device.dtype === 332 ||
device.dtype === 537 || device.dtype === 538 || device.dtype === 751 || device.dtype === 752 || device.dtype === 753 || device.dtype === 780 || device.dtype === 408 ||
device.dtype === 543 || device.dtype === 545) {
mainConfigJson.forEach(obj => {
if (obj.m.indexOf('temperature') !== -1) {
if (obj.m === 'temperature' || obj.m === 'temperature1') {
mainConfig.temperature = {value: obj.v, time: obj.t === null ? 0 : obj.t}
} else if (obj.m === 'temperature2') {
mainConfig.temperature2 = {value: obj.v, time: obj.t === null ? 0 : obj.t}
} else if (obj.m === 'temperature3') {
mainConfig.temperature3 = {value: obj.v, time: obj.t === null ? 0 : obj.t}
} else if (obj.m === 'temperature4') {
mainConfig.temperature4 = {value: obj.v, time: obj.t === null ? 0 : obj.t}
}

}
if (obj.m === 'voltage' || obj.m === 'votage') {
mainConfig.batteryVol = {value: obj.v, time: obj.t === null ? 0 : obj.t} 
}
if (obj.m.indexOf('humidity') !== -1) {
if (obj.m === 'humidity' || obj.m === 'humidity1') {
mainConfig.humidity = {value: obj.v, time: obj.t === null ? 0 : obj.t}
} else if (obj.m === 'humidity2') {
mainConfig.humidity2 = {value: obj.v, time: obj.t === null ? 0 : obj.t}
} else if (obj.m === 'humidity3') {
mainConfig.humidity3 = {value: obj.v, time: obj.t === null ? 0 : obj.t}
} else if (obj.m === 'humidity4') {
mainConfig.humidity4 = {value: obj.v, time: obj.t === null ? 0 : obj.t}
}

}
if (obj.m === 'battery') {
mainConfig.battery = {value: obj.v, time: obj.t === null ? 0 : obj.t} 
}
if (obj.m === 'active-state') {
mainConfig.activeState = {value: obj.v, time: obj.t === null ? 0 : obj.t} 
}
if (obj.m === 'gsm-strength-percent') {
mainConfig.rssi = {value: obj.v, time: obj.t === null ? 0 : obj.t} 
mainConfig.signal = {value: vm.parseSignal(device, mainConfig.rssi), time: obj.t === null ? 0 : obj.t}
}
if (obj.m === 'blood-oxygen') {
mainConfig.bloodOxygen = {value: obj.v, time: obj.t === null ? 0 : obj.t}
}
if (obj.m === 'heartrate') {
mainConfig.heartRate = {value: obj.v, time: obj.t === null ? 0 : obj.t}
}
if (obj.m === 'body-temperature') {
console.log(device.dtype, obj)
mainConfig.bodyTemperature = {value: obj.v, time: obj.t === null ? 0 : obj.t}
}
if (obj.m === 'device-status') {
if (obj.v === 'door-close') {
mainConfig.doorStatus = {value: 0, time: obj.t === null ? 0 : obj.t} 
} else if (obj.v === 'door-open') {
mainConfig.doorStatus = {value: 1, time: obj.t === null ? 0 : obj.t} 
}
}
if (obj.m === 'arm-status') {

if (obj.v === 'on') {
mainConfig.armStatus = {value: 1, time: obj.t === null ? 0 : obj.t}
} else if (obj.v === 'off') {
mainConfig.armStatus = {value: 0, time: obj.t === null ? 0 : obj.t}
}
}
})
}
}
return mainConfig
},
parseSetting (device) {
let dType = device.dtype
let setObj = {}
if (device.setting && device.setting !== '') {
device.setting.forEach(setting => {
let other = setting.other && setting.other !== '' ? JSON.parse(setting.other) : ''
if (dType === 301 || dType === 904 || dType === 905) {
if (setting.func === 'settemp') {
let values = setting.value.split('|')
setObj.isLowTemerature = values[0] === '1'
setObj.isHighTemerature = values[1] === '1'
setObj.lowTemperature = values[0] === '1' ? values[2] : ''
setObj.highTemperature = values[1] === '1' ? values[3] : ''
} else if (setting.func === 'sethumidity') {
let values = setting.value.split('|')
setObj.isLowHumidity = values[0] === '1'
setObj.isHighHumidity = values[1] === '1'
setObj.lowHumidity = values[0] === '1' ? values[2] : ''
setObj.highHumidity = values[1] === '1' ? values[3] : ''
}
} else if (dType === 753) {
if (setting.func === 'settemp1') {
let values = setting.value.split('|')
setObj.isLowTemerature = values[0] === '1'
setObj.isHighTemerature = values[1] === '1'
setObj.lowTemperature = values[0] === '1' ? values[2] : ''
setObj.highTemperature = values[1] === '1' ? values[3] : ''
} else if (setting.func === 'settemp2') {
let values = setting.value.split('|')
setObj.isLowTemerature2 = values[0] === '1'
setObj.isHighTemerature2 = values[1] === '1'
setObj.lowTemperature2 = values[0] === '1' ? values[2] : ''
setObj.highTemperature2 = values[1] === '1' ? values[3] : ''
} else if (setting.func === 'sethumidity1') {
let values = setting.value.split('|')
setObj.isLowHumidity = values[0] === '1'
setObj.isHighHumidity = values[1] === '1'
setObj.lowHumidity = values[0] === '1' ? values[2] : ''
setObj.highHumidity = values[1] === '1' ? values[3] : ''
} else if (setting.func === 'sethumidity2') {
let values = setting.value.split('|')
setObj.isLowHumidity2 = values[0] === '1'
setObj.isHighHumidity2 = values[1] === '1'
setObj.lowHumidity2 = values[0] === '1' ? values[2] : ''
setObj.highHumidity2 = values[1] === '1' ? values[3] : ''
}
} else if (dType === 751) {
if (setting.func === 'settemphumidity') {
setObj.isLowTemerature = false
setObj.isHighTemerature = false
setObj.isLowHumidity = false
setObj.isHighHumidity = false
setObj.highTemperature = other !== '' ? other.command1 : ''
setObj.lowTemperature = other !== '' ? other.command2 : ''
setObj.highHumidity = other !== '' ? other.command3 : ''
setObj.lowHumidity = other !== '' ? other.command4 : ''
}
} else if (dType === 752 || dType === 780 || device.dtype === 408) {
if (setting.func === 'setstatus') {
if (other.command1 === 'residence_time') {
setObj.residenceTime = other !== '' ? other.command2 / 60 : ''
}
} else if (setting.func === 'setinstallheight') {
setObj.installHeight = other !== '' ? other.command1 : ''
}
} else if (dType === 906 || dType === 920) {
if (setting.func === 'outstatus') {
if (setting.value === '2|0|0') {
setObj.outputStatus = 2
} else if (setting.value === '1|0|0') {
setObj.outputStatus = 1
}
} else if (setting.func === 'setheartbeat') {
setObj.heartbeatDuration = parseInt(setting.value.split('|')[1]) * 10
}
} else if (dType === 402 || dType === 404 || dType === 504 || dType === 508 || dType === 509 || dType === 510) {
if (setting.func === 'isactivity') {
setObj.isActivity = other !== ''
if (setObj.isActivity) {
let periodValue = setting.value
let seconds = parseInt(periodValue)
setObj.periodHour = Math.floor(seconds / 3600)
setObj.periodMinute = seconds % 3600 / 60
setObj.durationStart = other !== '' ? parseInt(other.begintime.split(':')[0]) : ''
setObj.durationEnd = other !== '' ? parseInt(other.endtime.split(':')[0]) : ''
}
}
} else if (dType === 902 || dType === 701) {
if (setting.func === 'sosphone') {
setObj.sosPhone = other !== '' ? other.sosphone : ''
setObj.phone1 = other !== '' ? other.phone1 : ''
setObj.name1 = other !== '' && other.name1 ? other.name1 : '号码一'
setObj.phone2 = other !== '' ? other.phone2 : ''
setObj.name2 = other !== '' && other.name2 ? other.name2 : '号码二'
} else if (dType === 701 && setting.func === 'sendmessage310') {
setObj.notifyContent = other !== '' ? other.command2 : ''
}
} else if (dType === 700) {
if (setting.func === 'setalarmcallphone') {
setObj.alarmPhone = other !== '' ? other.command1 : ''
} else if (setting.func === 'phonebook') {

let phoneBookList = []
if (other !== '') {
if (other.command1 !== '') {
let dataArr = other.command1.split('|')
phoneBookList.push({name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]})
}
if (other.command2 !== '') {
let dataArr = other.command2.split('|')
phoneBookList.push({name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]})
}
if (other.command3 !== '') {
let dataArr = other.command3.split('|')
phoneBookList.push({name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]})
}
if (other.command4 !== '') {
let dataArr = other.command4.split('|')
phoneBookList.push({name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]})
}
if (other.command5 !== '') {
let dataArr = other.command5.split('|')
phoneBookList.push({name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]})
}
if (other.reserved1 !== '') {
let dataArr = other.reserved1.split('|')
phoneBookList.push({name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]})
}
if (other.reserved2 !== '') {
let dataArr = other.reserved2.split('|')
phoneBookList.push({name: dataArr[0], phone: dataArr[1], icon: dataArr[2], im: dataArr[3]})
}
}
setObj.phoneBookList = phoneBookList
} else if (setting.func === 'setfm') {

let fmList = []
if (other !== '') {
if (other.command1 !== '') {
let dataArr = other.command1.split('#')
fmList.push({name: dataArr[0], frequency: dataArr[1]})
}
if (other.command2 !== '') {
let dataArr = other.command2.split('#')
fmList.push({name: dataArr[0], frequency: dataArr[1]})
}
if (other.command3 !== '') {
let dataArr = other.command3.split('#')
fmList.push({name: dataArr[0], frequency: dataArr[1]})
}
if (other.command4 !== '') {
let dataArr = other.command4.split('#')
fmList.push({name: dataArr[0], frequency: dataArr[1]})
}
if (other.command5 !== '') {
let dataArr = other.command5.split('#')
fmList.push({name: dataArr[0], frequency: dataArr[1]})
}
if (other.reserved1 !== '') {
let dataArr = other.reserved1.split('#')
fmList.push({name: dataArr[0], frequency: dataArr[1]})
}
if (other.reserved2 !== '') {
let dataArr = other.reserved2.split('#')
fmList.push({name: dataArr[0], frequency: dataArr[1]})
}
}
setObj.fmList = fmList
}
} else if (dType === 310 || dType === 311 || dType === 312) {
if (setting.func === 'setclock310') {
let clocks = other !== '' && other.command1 !== '' ? other.command1.split('|') : []
let clockList = []
clocks.forEach(str => {
let clock = str.split('#')
clockList.push({id: clock[0], timeType: clock[1], time: clock[2], content: clock[3]})
})
setObj.alarmClockList = clockList
} else if (setting.func === 'phonebook310') {
let phones = other !== '' && other.command1 !== '' ? other.command1.split('u0026') : []
let phoneList = []
phones.forEach(str => {
let phone = str.split('|')
phoneList.push({name: phone[0], phone: phone[1], url: phone[2], imNum: phone[3]})
})
setObj.addressBookList = phoneList
} else if (setting.func === 'requirelocation310') {
let command1 = other !== '' && other.command1 !== '' ? other.command1.split('|') : ''
setObj.locateObj = {
func: command1[0] === '1' ? 1 : -1, // 1 打开 -1 关闭
num: command1[1], // 定位次数
time: command1[2],
mode: command1[3]
}
} else if (setting.func === 'requirelocationperiod310') {
let command1 = other !== '' && other.command1 !== '' ? other.command1.split('|') : ''
let func = command1 !== '' ? command1[0] : ''
let locations = command1 !== '' ? command1[1].split(';') : []
let locationList = []
if (func === '2') {
locations.forEach(location => {
let times = location.split('#')
let obj = {
time: times[2],
mode: times[3],
startTime: times[0],
endTime: times[1]
}
locationList.push(obj)
})
}
setObj.locateList = locationList
} else if (setting.func === 'sendmessage310') {
setObj.notifyObj = {
type: other.command1,
title: other.command1 === '2' ? other.command2 : '',
content: other.command1 === '2' ? other.command3 : other.command2
}
}
} else if (dType === 330 || dType === 332) {
if (setting.func === 'setclock330') {
let command1 = other !== '' && other.command1 !== '' ? other.command1.split('@') : []
setObj.alarmClockList = [
{id: 1, time: '00:00', weeks: [], type: 1},
{id: 2, time: '00:00', weeks: [], type: 1},
{id: 3, time: '00:00', weeks: [], type: 1}
]
command1.forEach(clock => {
let clocks = clock.split('!')
let times = clocks[0].split('=')
let weeks = clocks[1] === '' ? [] : clocks[1].split('+')
let endWeeks = []
weeks.forEach(we => {
endWeeks.push(parseInt(we))
})
let obj = {id: parseInt(times[0]), time: times[1].slice(0, 2) + ':' + times[1].slice(2, 4), weeks: endWeeks, type: parseInt(clocks[2])}
let idx = setObj.alarmClockList.findIndex(r => r.id === obj.id)
if (idx !== -1) {
setObj.alarmClockList[idx] = obj
}
})
} else if (setting.func === 'normalbutton') {
let command1 = other !== '' && other.command1 !== '' ? other.command1.split('|') : []
let command2 = other !== '' && other.command2 !== '' ? other.command2.split('|') : []
let phoneList = []
for (let i = 0; i <= command1.length - 1; i++) {
phoneList.push({phone: command1[i], name: command2[i]})
}
setObj.addressBookList = phoneList
} else if (setting.func === 'phonein330') {
let command1 = other !== '' && other.command1 !== '' ? other.command1.split('!') : []
let whiteList = []
command1.forEach(item => {
let phone = item.split('=')
whiteList.push({phone: phone[0], time: phone[1]})
})
setObj.whiteList = whiteList
} else if (setting.func === 'setfrequencylocation') {
let command1 = other !== '' && other.command1 !== '' ? other.command1 : ''
setObj.locateObj = {time: command1}
}
}
})
}
return setObj
},
parseSignal (device, deviceRSSI) {

let signal = -1
if (deviceRSSI) {
let rssi = deviceRSSI
if (device.dtype === 402 || device.dtype === 404 || device.dtype === 504 || device.dtype === 506 || device.dtype === 507 ||
device.dtype === 508 || device.dtype === 509 || device.dtype === 510 || device.dtype === 511 || device.dtype === 904 ||
device.dtype === 905) {
if (rssi < -114) {
signal = 0
} else if (rssi >= -114 && rssi < -105) {
signal = 1
} else if (rssi >= -105 && rssi < -95) {
signal = 2
} else if (rssi >= -95 && rssi < -85) {
signal = 3
} else {
signal = 4
}
} else if (device.dtype === 505) {
if (rssi === 1) {
signal = 0
} else if (rssi === 2) {
signal = 1
} else if (rssi === 3) {
signal = 2
} else if (rssi === 4) {
signal = 3
} else if (rssi === 5) {
signal = 4
}
} else if (device.dtype === 537 || device.dtype === 538 || device.dtype === 543 || device.dtype === 752 || device.dtype === 753 || device.dtype === 780 || device.dtype === 408) {
if (rssi <= 20) {
signal = 0
} else if (rssi > 20 && rssi <= 40) {
signal = 1
} else if (rssi > 40 && rssi <= 60) {
signal = 2
} else if (rssi > 60 && rssi <= 80) {
signal = 3
} else {
signal = 4
}
}
}
return signal
},
getDevices (rooms, devices) {
let vm = this

rooms.filter(r => r.role === 'owner').forEach(room => {
vm.selectHomeArr.push({name: room.name, id: room.id})
if (room.devices) {
vm.deviceArr.push({name: room.name, nameShow: '未分组', id: room.id, deviceList: this.getDevicesByRoom(devices, room.devices)})
}
rooms.filter(r => r.parentid === room.id).forEach(childRoom => {
vm.deviceArr.push({name: room.name, nameShow: childRoom.name, id: room.id, deviceList: this.getDevicesByRoom(devices, childRoom.devices)})
})
})

rooms.filter(r => r.role !== 'owner' && r.level === 1).forEach(room => {
vm.selectHomeArr.push({name: room.name, id: room.id})
if (room.devices) {
vm.deviceArr.push({name: room.name, nameShow: '未分组', id: room.id, deviceList: this.getDevicesByRoom(devices, room.devices)})
}
rooms.filter(r => r.parentid === room.id).forEach(childRoom => {
vm.deviceArr.push({name: room.name, nameShow: childRoom.name, id: room.id, deviceList: this.getDevicesByRoom(devices, childRoom.devices)})
})
})

if (devices.find(r => r.phonedevicerole === 'normal' || r.phonedevicerole === '')) {
vm.selectHomeArr.push({name: '成员分享', id: -1})
vm.deviceArr.push({name: '成员分享', nameShow: '成员分享', id: -1, deviceList: devices.filter(r => r.phonedevicerole === 'normal' || r.phonedevicerole === '')})
}

if (devices.find(r => r.phonedevicerole !== 'normal' && r.phonedevicerole !== '' && r.areaid === 0 && r.roomid === 0)) {
vm.selectHomeArr.push({name: '默认场所', id: -2})
vm.deviceArr.push({name: '默认场所', nameShow: '默认场所', id: -2, deviceList: devices.filter(r => r.phonedevicerole !== 'normal' && r.phonedevicerole !== '' && r.areaid === 0 && r.roomid === 0)})
}

let unKnownDevice = []
devices.forEach(device => {
if ((device.areaid !== 0 || device.roomid !== 0) && !rooms.find(r => r.id === device.areaid || r.id === device.roomid)) {
unKnownDevice.push(device)
}
})
if (unKnownDevice.length > 0) {
vm.selectHomeArr.push({name: '未知设备', id: -4})
vm.deviceArr.push({name: '未知设备', nameShow: '未知设备', id: -4, deviceList: unKnownDevice})
}
},
getDevicesByRoom (devices, roomDevices) {
let arr = []
if (roomDevices) {
roomDevices.forEach(device => {
let obj = devices.find(r => r.id === device.did)
if (obj) {
arr.push(obj)
}
})
}
return arr
},
getShowDevices () {
if (this.selectHome.id === 0) {
this.showDeviceArr = this.deviceArr
} else {
this.showDeviceArr = this.deviceArr.filter(r => r.id === this.selectHome.id)
}
},

getDeviceImageUrl (dType) {
let img = this.deviceImgArr[this.deviceImgArr.length - 1].imgUrl
let deviceImg = this.deviceImgArr.find(r => r.dtype === dType)
if (deviceImg) {
img = deviceImg.imgUrl
}
return img
},

getDeviceVoltage (item) {
let result = '--'
if (item.mainConfig.batteryVol) {
let batteryVol = item.mainConfig.batteryVol.value
if (item.dtype === 402 || item.dtype === 404 || item.dtype === 505) {
result = Math.round((batteryVol / 1000) * 10) / 10
} else if (item.dtype === 503 || item.dtype === 504 || item.dtype === 506 || item.dtype === 507 ||
item.dtype === 508 || item.dtype === 509 || item.dtype === 510 || item.dtype === 511 || item.dtype === 538 ||
item.dtype === 904 || item.dtype === 905) {
result = batteryVol > 100 ? Math.round((batteryVol / 100) * 10) / 10 : Math.round(batteryVol * 10) / 10
} else {
result = batteryVol
}
}
return result === '--' || (result + '').indexOf('V') !== -1 ? result : result + 'V'
},

getDeviceBattery (item) {
let result = '--'
if (item.dtype === 901) {
result = item.battery
} else {
if (item.mainConfig.battery) {
result = item.mainConfig.battery.value
}
}
return result === '--' || (result + '').indexOf('%') !== -1 ? result : result + '%'
},

getDeviceTamperStatus (item) {
let result = '--'
if (item.mainConfig.tamperStatus) {
if (item.mainConfig.tamperStatus.value === 0) {
result = '压下'
} else if (item.mainConfig.tamperStatus.value === 1) {
result = '打开'
} else {
result = item.mainConfig.tamperStatus.value
}
}
return result
},

getDevicePressValue (item) {
let result = '--'
if (item.mainConfig.pressValue) {
result = item.mainConfig.pressValue.value
switch (item.mainConfig.pressUnits.value) {
case 0:
result += ' mPa'
break
case 1:
result += ' Pa'
break
case 2:
result += ' hPa'
break
case 3:
result += ' kPa'
break
}
}
return result
},

getDeviceTemperature (item) {
let result = ''
result = item.mainConfig.temperature ? item.mainConfig.temperature.value : '--'
result = result === '--' || (result + '').indexOf('℃') !== -1 ? result : result + '℃'
return result
},

getDeviceHumidity (item) {
let result = ''
result = item.mainConfig.humidity ? item.mainConfig.humidity.value : '--'
result = result === '--' || (result + '').indexOf('%') !== -1 ? result : result + '%'
return result
},

getDeviceProbe (item, type) {
let result = ''
let result1 = ''
let result2 = ''
let lastOnline = item.last_online
if (type === 'probe1') {
if (item.mainConfig.temperature && Math.floor((new Date(lastOnline).getTime() - item.mainConfig.temperature.time) / 60000) <= 5) {
result1 = item.mainConfig.temperature.value + '℃'
} else {
result1 = '--'
}
if (item.mainConfig.humidity && Math.floor((new Date(lastOnline).getTime() - item.mainConfig.humidity.time) / 60000) <= 5) {
result2 = item.mainConfig.humidity.value + '%'
} else {
result2 = '--'
}
} else if (type === 'probe2') {
if (item.mainConfig.temperature2 && Math.floor((new Date(lastOnline).getTime() - item.mainConfig.temperature2.time) / 60000) <= 5) {
result1 = item.mainConfig.temperature2.value + '℃'
} else {
result1 = '--'
}
if (item.mainConfig.humidity2 && Math.floor((new Date(lastOnline).getTime() - item.mainConfig.humidity2.time) / 60000) <= 5) {
result2 = item.mainConfig.humidity2.value + '%'
} else {
result2 = '--'
}
} else if (type === 'probe3') {
if (item.mainConfig.temperature3 && Math.floor((new Date(lastOnline).getTime() - item.mainConfig.temperature3.time) / 60000) <= 5) {
result1 = item.mainConfig.temperature3.value + '℃'
} else {
result1 = '--'
}
} else if (type === 'probe4') {
if (item.mainConfig.temperature4 && Math.floor((new Date(lastOnline).getTime() - item.mainConfig.temperature4.time) / 60000) <= 5) {
result1 = item.mainConfig.temperature4.value + '℃'
} else {
result1 = '--'
}
}

if (result1 === '') {
result = result1
} else if (result2 === '') {
result = result2
} else {
result = result1 + ' / ' + result2
}

return result
},

getSignal (item) {
let result = '--'
if (item.mainConfig.signal) {
let signal = item.mainConfig.signal.value
if (signal === 0) {
result = '极弱'
} else if (signal === 1) {
result = '弱'
} else if (signal === 2) {
result = '一般'
} else if (signal === 3) {
result = '强'
} else if (signal === 4) {
result = '极好'
}
}
return result
},
getTipInfoText (item, category) {
let result = ''
if (category === 'voltage') {
let voltage = this.getDeviceVoltage(item)
if (voltage !== '--') {
if (parseFloat(voltage.slice(0, -1)) <= 2.4) {
result = ' 电量低！'
}
}
}
return result
},



isHaveChild (type) {

return [400, 700, 701, 800].indexOf(type) >= 0
},
isShowVoltage (type) {

return [301, 402, 404, 503, 504, 505, 506, 507, 508, 509, 510, 511, 537, 538, 543, 753, 904, 905].indexOf(type) >= 0
},
isShowBattery (type) {

return [503, 545, 751, 901].indexOf(type) >= 0
},
isShowTamper (type) {

return [505].indexOf(type) >= 0
},
isShowPress (type) {

return [503].indexOf(type) >= 0
},
isShowTemperature (type) {

return [301, 504, 506, 507, 508, 509, 510, 511, 537, 538, 543, 904, 905, 751].indexOf(type) >= 0
},
isShowHumidity (type) {

return [751].indexOf(type) >= 0
},
isShowProbe (type, category) {

let types = []
if (category === 'probe1') {
types.push(753)
} else if (category === 'probe2') {
types.push(753)
} else if (category === 'probe3') {
} else if (category === 'probe4') {
}
return types.indexOf(type) >= 0
},
isShowSignal (type) {

return [402, 404, 504, 505, 506, 507, 508, 509, 510, 511, 537, 538, 543, 752, 780, 408, 904, 905].indexOf(type) >= 0
},

isNoOnline (type) {
return [402, 800].indexOf(type) >= 0
},
isHaveDefence (type) {
return [543, 700, 800].indexOf(type) >= 0
},
isHaveLock (type) {
return [400, 401].indexOf(type) >= 0
},
isHaveDoor (type) {
return [402, 404, 504, 508, 538, 543, 509].indexOf(type) >= 0
},
isHaveMap (type) {
return [99, 300, 301, 310, 311, 312, 330, 331, 332, 901].indexOf(type) >= 0
},
isHaveElectric (type) {
return [511, 904, 905].indexOf(type) >= 0
},
isHaveActive (type) {
return [752, 780, 408].indexOf(type) >= 0
},

nullMethod () {

},
changeDefence (item) {
let data = {
dids: [item.id],
properties: [{key: 'defence', value: item.setting[0].value}]
}
setdevice(data).then(res => {
if (item.setting[0].value === 'on') {
this.$toast('布防成功')
} else {
this.$toast('撤防成功')
}
}).catch(() => {
this.$toast('失败')
this.upCallback()
})
},
changeLock (item) {
if (item.isonline !== 1) {
return
}
if (item.dtype === 400) {
let id = item.id
item.mainConfig.lockStatus.value = 0
let data = {
did: id,
cmd: 'openlock',
value: '1'
}
sendcommandlock(data).then(res => {
item.mainConfig.lockStatus.value = 1
}).catch(() => {})
} else if (item.dtype === 401) {
let data = {
did: item.id,
cmd: 'open'
}
sendcommand(data).then(res => {
this.$toast('指令发送成功')
}).catch(() => {})
}
},


getIsOnlineClass (item) {
let className = 'item-div-active'

if (!this.isNoOnline(item.dtype)) {
if (item.isonline !== 1) {
className = 'item-div'
}
}
return className
},

openHomeClick () {
this.selectHomeShow = true
},
selectHomeClick (item) {
if (item.id !== this.selectHome.id) {
this.selectHomeShow = false
this.selectHome = item
this.getShowDevices()
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/NewDevice1.vue